import { useMutation } from '@tanstack/react-query';
import { triggerChatWorkflow } from '@/services/DataService';
import type { TriggerChatWorkflowPayload } from '@/services/DataService';

export const useChatWorkflow = () => {
  return useMutation({
    mutationFn: (payload: TriggerChatWorkflowPayload) =>
      triggerChatWorkflow(payload),
  });
};